import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { cssGenerator } from '@/mixins/css-generator';
import tooltip from '@/mixins/components/tooltip';
import { SQUASH_DROPLET } from '@/constants';
import DropletOptions from '../_bubble-options';
import GroupListOptions from './components/_edit-options';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('group-list', {
  template: require('./template.html'),
  name: 'group-list',
  mixins: [cssGenerator],
  computed: {
    ...mapGetters([
      'currentSite',
      'currentPage',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'dragging',
      'globalBubbleOptionsOpen',
      'globalOpenModal',
    ]),
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    hideTransform() {
      return this.dragging || this.globalBubbleOptionsOpen;
    },
    profile() {
      return this._dropletType(this.droplet);
    },
    activeSiteType() {
      return this.droplet.siteType || this.currentSite.type;
    },
    groups() {
      const enabled = this.currentSite.dynamic && this.currentSite.dynamic[this.activeSiteType];
      const groups = enabled ? _.cloneDeep(enabled.groups || []) : [];
      _.forEach(groups, (group) => {
        group.thumbnail = this._servePrefix(group.thumbnail) + group.thumbnail;
      });
      return groups.sort((a, b) => new Date(b.created) - new Date(a.created));
    },
    loadMoreNeeded() {
      return this.groups.length > this.droplet.visible;
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', .drzGroupList' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
  },
  data() {
    return {
      type: dropletSchema.type,
      SQUASH_DROPLET,
      display: {
        top: null,
        left: null,
        right: null,
        bottom: null,
        ctPaddingTop: null,
        ctPaddingBottom: null,
        ctPaddingLeft: null,
        ctPaddingRight: null,
        transform: null,
        perspective: null,
        previewSize: null,
        loadMoreSize: null,
        cardWidthTop: null,
        cardWidthBottom: null,
        cardWidthRight: null,
        cardWidthLeft: null,
        previewLetterSpace: null,
        loadLetterSpace: null,
        'letter-spacing': null,
        'border-top-left-radius': null,
        'border-top-right-radius': null,
        'border-bottom-left-radius': null,
        'border-bottom-right-radius': null,
        'padding-top': null,
        'padding-bottom': null,
        'padding-left': null,
        'padding-right': null,
        'box-shadow': null,
        'font-size': null,
        'border-top-width': null,
        'margin-bottom': null,
      },
      hidden: false,
      dropletHovered: false,
      setBubbleSize: 'dropletBubble-normal',
      showEditBubble: false,
      showRevealClass: false,
    };
  },
  props: ['droplet', 'items', 'index'],
  components: {
    DropletOptions,
    GroupListOptions,
    tooltip,
  },
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    'activeDroplet._id': function c(id) {
      if (!id) {
        this.showRevealClass = false;
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '.drzGroupList',
        });
      }
    },
    showRevealClass() {
      this._debounce(() => {
        // we need to rebounce the plugin here since the animation
        // classes remove the plugin classes on each item
        this.destroyPlugin();
        this.initPlugin();
      }, 250);
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
    globalOpenModal(open) {
      if (!open) {
        // we trigger the rerender here if user is adding new dynamic data
        this.destroyPlugin();
        this.initPlugin();
      }
    },
  },
  mounted() {
    this.callCssGenerator();
    this.observeVisibility();
    this.initPlugin();
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drp: this.droplet,
      });
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
    initPlugin() {
      const $droplet = $(this.$refs.groupList);
      $droplet.drzLoadMore({
        visible: this.droplet.visible,
        assets: 'src',
        classes: {
          show: 'drzGroupList-item-show',
          img: 'drzGroupList-item-img',
          footer: 'drzGroupList-footer',
          footerHidden: 'drzGroupList-footerHidden',
          item: 'drzGroupList-item',
          loadMore: 'drzGroupList-more',
        },
      });
    },
    destroyPlugin() {
      const $droplet = $(this.$refs.groupList);
      return new Promise((res) => {
        $droplet.drzLoadMore.destroy();
        res();
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/group-list/index.js